// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader__3dzrr","load7":"load7__SixZ_"};